'use client';

import React from 'react';
import styled from '@emotion/styled';
import { Typography } from '@diritto/common/style/typography';
import { ButtonSize } from 'constants/button';
import { MagnifierIcon } from 'icons/ritto/Magnifier';
import { Error } from 'ui-components/common/Error';
import { HomeLinkButton } from 'ui-components/common/HomeLinkButton';

export const ErrorStatus404 = () => (
  <StyledWrap>
    <Error
      icon={<MagnifierIcon />}
      title={'페이지를 찾을 수 없어요.'}
      description={'잘못된 주소거나 변경 혹은 삭제되어 \n 접근할 수 없어요.(에러코드: 404)'}>
      <HomeLinkButton
        className={'no-underline'}
        label={'홈으로 가기'}
        replace
        fullWidth
        buttonTypography={Typography.XXXSmall}
        size={ButtonSize.Small}
      />
    </Error>
  </StyledWrap>
);

const StyledWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 100px;
`;
